import type { AxiosResponse } from 'axios';

import { getContentDispositionFilename } from './getContentDispositionFilename';
import { saveBlob } from './saveBlob';

export const downloadFileWithFilename = (response: AxiosResponse) => {
  // We first attempt to read the filename from the content-disposition response header
  const disposition = response.request.getResponseHeader('content-disposition');
  const dispositionFilename = getContentDispositionFilename(disposition);

  saveBlob({ blob: response.data, fileName: dispositionFilename });
};
